<template>
    <div class="mask" v-show="isShow" ref="mask" @contextmenu="contextmenu">
        <div class="inner" @contextmenu="contextmenu">
            <h5>提示</h5>
            <div class="content">
                {{message}}
            </div>
            <div class="foot">
                <button @click.stop="cancle">否</button>
                <button @click.stop="confirm">是</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name: 'confirm',

    data(){
        return {
            isShow: false,
            message: ''
        }
    },

    methods: {

        confirm(){
            this.isShow = false
            this.successHandler && this.successHandler()
        },

        cancle(){
            this.isShow = false
            this.cancelHandler && this.cancelHandler()
        },

        contextmenu(e){
            e.preventDefault()
        }
    }
}
</script>

<style lang="scss" scoped>
.mask{
    width: 100vw; height: 100vh; background-color: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; position: fixed; top: 0; left: 0; z-index: 9999;
    .inner{
        h5{ height: 80px; width: calc(100% - 40px); line-height: 80px; text-align: center; font-size: 20px; font-weight: normal; border-bottom: 1px solid rgba(0,0,0,0.1); margin: 0 20px; }
        width: 560px; height: 280px; background-color: #fff; border-radius: 10px;
        .content{
            height: 115px; text-align: center; line-height: 130px;
        }
        .foot{
            padding: 10px 0; display: flex; justify-content: center;
            button{
                width: 130px; height: 40px;text-align: center; line-height: 40px; color: #8492A6; margin: 0 10px; border-radius: 20px; cursor: pointer;
                &:nth-child(1){
                    background-color: #FFF; border: 1px solid #8492A6; height: 38px; line-height: 38px;
                }
                &:nth-child(2){
                    background-color: #1458EA; color: #FFF;
                }
            }
        }
    }
}
</style>